import { ManifestBlockReason } from "generated-graphql/graphql";

/**
 * Reviewer-facing labels for the manifest block reasons. The enum is an implementation
 * detail; these strings are what a reviewer reads in the block dialog, the queue's
 * Blocked column, and the CSV export (apps/lambdas/export-data mirrors them).
 */
export const MANIFEST_BLOCK_REASON_LABELS: Record<ManifestBlockReason, string> = {
  [ManifestBlockReason.DocumentMissing]: "No document",
  [ManifestBlockReason.DocumentPagesMissing]: "Missing pages",
  [ManifestBlockReason.DocumentIllegible]: "Illegible",
  [ManifestBlockReason.DocumentWrongFile]: "Wrong document",
  [ManifestBlockReason.VendorDataMissing]: "No vendor data",
  [ManifestBlockReason.EmanifestRecordMissing]: "No e-Manifest record",
  [ManifestBlockReason.RcrainfoAccessDenied]: "No RCRAInfo access",
  [ManifestBlockReason.BadComparison]: "Comparison looks wrong",
  [ManifestBlockReason.NeedsSeniorReview]: "Needs senior review",
  [ManifestBlockReason.Other]: "Other",
};

/** The block dialog's grouped reason picker: four groups keep the list scannable. */
export const MANIFEST_BLOCK_REASON_GROUPS: {
  label: string;
  reasons: ManifestBlockReason[];
}[] = [
  {
    label: "The manifest document",
    reasons: [
      ManifestBlockReason.DocumentMissing,
      ManifestBlockReason.DocumentPagesMissing,
      ManifestBlockReason.DocumentIllegible,
      ManifestBlockReason.DocumentWrongFile,
    ],
  },
  {
    label: "Missing source data",
    reasons: [
      ManifestBlockReason.VendorDataMissing,
      ManifestBlockReason.EmanifestRecordMissing,
      ManifestBlockReason.RcrainfoAccessDenied,
    ],
  },
  {
    label: "Needs someone at Encamp",
    reasons: [ManifestBlockReason.BadComparison, ManifestBlockReason.NeedsSeniorReview],
  },
  {
    label: "Something else",
    reasons: [ManifestBlockReason.Other],
  },
];
